import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CreateCustomerAndSendDefaultReviewRequestRequest,
  CreateCustomerAndSendDefaultReviewRequestResponse,
  Customer,
  CustomerVoiceApiService,
} from '@vendasta/customer-voice-service';

export interface BusinessInfo {
  businessName: string;
  businessLogoUrl: string;
  templateType: string;
}

export const TEMPLATE_TYPE_SMS = 'sms';

interface GetBusinessInfoResponse {
  business_name: string;
  image_url: string;
  template_type: string;
}

@Injectable()
export class CustomerFormService {
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private customerVoiceApiService: CustomerVoiceApiService,
  ) {}

  hostName(): string {
    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        return 'https://customer-voice-service-api.vendasta-local.com';
      case Environment.DEMO:
        return 'https://customer-voice-service-api-demo.vendasta-internal.com';
      case Environment.PROD:
        return 'https://customer-voice-service-api-prod.apigateway.co';
    }

    return '';
  }

  public createCustomerAndSendReviewRequest(
    customer: Customer,
    token: string,
  ): Observable<CreateCustomerAndSendDefaultReviewRequestResponse> {
    const createCustomerAndSendReviewRequest = new CreateCustomerAndSendDefaultReviewRequestRequest({
      customer: customer,
      responseToken: token,
    });
    return this.customerVoiceApiService.createCustomerAndSendDefaultReviewRequest(createCustomerAndSendReviewRequest);
  }

  loadBusinessInfo(businessID: string): Observable<BusinessInfo> {
    const hostName = this.hostName();
    const url = hostName + '/get-business-info';
    const body: {
      [key: string]: any;
    } = {};
    body['business_id'] = businessID;
    return this.httpClient
      .post<GetBusinessInfoResponse>(url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        withCredentials: true,
      })
      .pipe(
        map((result: GetBusinessInfoResponse) => {
          return {
            businessName: result.business_name,
            businessLogoUrl: result.image_url,
            templateType: result.template_type,
          } as BusinessInfo;
        }),
        catchError((err: Error) => {
          console.error(err.message);
          return of(null);
        }),
      );
  }
}
